import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FacialRecognitionUploaderInfoComponent } from '../facial-recognition-uploader-info/facial-recognition-uploader-info.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'fgb-facial-recognition-review-photo',
  templateUrl: './facial-recognition-review-photo.component.html',
  styleUrl: './facial-recognition-review-photo.component.scss',
})
export class FacialRecognitionReviewPhotoComponent implements OnInit {
  @Input() uploadedImage: FormControl = new FormControl();
  @Input() formData: FormControl = new FormControl();
  @Input() stepCounter: number = 2;
  @Input() isUploadInfo: boolean = false;
  @Output() isUploadInfoChange = new EventEmitter<boolean>();
  @Output() setStep = new EventEmitter();
  @Output() validatePhoto = new EventEmitter<any>();
  @Output() previousStepChange = new EventEmitter();
  @Output() nextStepChange = new EventEmitter();
  imageSrc: string = '';
  destroy$ = new Subject<void>();

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.uploadedImage.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.imageSrc = data;
      }
    });
  }

  retakePhoto() {
    if (this.uploadedImage.value) this.uploadedImage.setValue(null);
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(FacialRecognitionUploaderInfoComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'facial-recognition-selection-modal',
      centered: true,
    });
    modalRef.componentInstance.isfacialRouteLinkDisabled = true;

    modalRef.result.then(
      (result) => {
        if (result) {
          this.isUploadInfo = result.isUploadInfo;
          this.isUploadInfoChange.emit(this.isUploadInfo);
          if (result.isUploadInfo) {
            result.uploadedImageForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
              if (data) {
                this.uploadedImage.setValue(data);
                this.imageSrc = data;
              }
            });
          }
          this.formData.setValue(result.formData.value);
          this.setStep.emit(result.goToStep);
        }
      },
      (reason) => {}
    );
  }

  submitphoto() {
    this.setStep.emit(3);
    this.validatePhoto.emit();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
